import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import React from 'react'

import styles from './Dialog.module.sass'

const ErrorDialog = (props) => {
	const { className, data, resolve } = props
	const { i18n } = useGlobal()
	return (
		<div className={`${styles['root'] || ''} ${className || ''}`}>
			<div>
				{data?.error?.htmlMessage ? (
					<small
						className={styles['dialog-title']}
						dangerouslySetInnerHTML={{
							__html: data.error.htmlMessage,
						}}
					/>
				) : (
					<small className={styles['dialog-title']}>
						{data?.error?.message || i18n`An error has occurred`}
					</small>
				)}
			</div>
			<HStack
				className={styles['actions-container']}
				gap='xsmall'
				justify='flex-end'
			>
				<ActionButton type='button' primary onClick={resolve}>
					<small>
						<strong>{i18n`Ok`}</strong>
					</small>
				</ActionButton>
			</HStack>
		</div>
	)
}

export default ErrorDialog
